import { Divider, Stack, toast } from 'component-library';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import { useAllPlotsForOrganization } from '@/pages/shared/hooks/usePlotsForOrganization';

import { useIsLandPortionProject } from '../../hooks/useIsLandPortionProject';
import { EditSettings } from './components/EditSettings';
import { LabelFilters } from './components/LabelFilters';

export const ScenarioEditor = () => {
  const { t } = useTranslation();
  const currentFormValues = useWatch();
  const [previousFormValues, setPreviousFormValues] = useState(currentFormValues);

  useEffect(() => {
    const hasFormChanged = JSON.stringify(previousFormValues) !== JSON.stringify(currentFormValues);

    if (hasFormChanged) {
      setPreviousFormValues(currentFormValues);

      toast({
        toastId: 'projection-is-updated-toast',
        title: t('shared.projects.project.impactProjections.scenarioEditor.toast.success'),
        type: 'success',
        autoClose: 5_000,
      });
    }
  }, [previousFormValues, currentFormValues, t]);

  return (
    <Stack
      data-testid='scenario-editor'
      spacing={6}
      className='whitespace-pre-wrap rounded-2xl bg-white-100 p-6 text-text-secondary'
    >
      <Stack className='typography-overline font-medium text-black-100'>
        {t('shared.projects.project.impactProjections.scenarioEditor.title')}
      </Stack>
      <Stack className='typography-body1 flex-col justify-between md:flex-row'>
        <ScenarioInfoLabel />
        <EditSettings />
      </Stack>
      <Divider />
      <LabelFilters />
      <Stack className='typography-caption rounded-lg bg-bg-light-grey p-4'>
        {t('shared.projects.project.impactProjections.scenarioEditor.helper')}
      </Stack>
    </Stack>
  );
};

const ScenarioInfoLabel = () => {
  const { t } = useTranslation();
  const plots = useAllPlotsForOrganization().data.results;

  const { landPortionId, timeFrame } = useWatch();
  const isLandPortionProject = useIsLandPortionProject();

  const landPortion = isLandPortionProject
    ? t('shared.projects.project.impactProjections.scenarioEditor.editSettings.form.landPortion.defaultLandPortion')
    : plots.find((plot) => plot.id === landPortionId)?.name;

  return (
    <Trans
      i18nKey={
        isLandPortionProject
          ? 'shared.projects.project.impactProjections.scenarioEditor.projectSettingsInfo'
          : 'shared.projects.project.impactProjections.scenarioEditor.plotSettingsInfo'
      }
      values={{ landPortion, timeFrame }}
      components={{
        strong: <span className='typography-body1Semibold' />,
      }}
    />
  );
};
